import Navbar from '../navbar/navbar.jsx';
import './notfound.css';
export default function Notfound(){


    return (
        <>
        <Navbar/>
        <div className = 'notfound'>
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>Sorry, the page you are looking for does not exist.</p>
        </div>
        </>
    );
    }